<template>
  <div>
    <div
      class="block-icon-reglement-fac mr-1"
      @click.prevent.stop="ribFiliale(item)"
      title="Ribs"
    >
      <font-awesome-icon icon="dollar-sign" />
    </div>
    <!--GESTION DES RIBS-->
    <v-dialog
      v-model="addModalRib"
      persistent
      max-width="1400px"
      :scrollable="true"
      :hide-overlay="true"
      no-click-animation
      content-class="custom-vuetify-dialog-list"
    >
      <v-card>
        <v-card-title class="text-h6 title-modal">
          <v-label class="label-header">GESTION DES RIBS </v-label>
          <v-btn
            class="btn-close-header"
            icon
            @click="handleModalRib('rib', 'hide')"
            title="Fermer"
            color="#704ad1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="line-hr"></v-divider>
        <v-card-text class="body-card">
          <div v-if="getRibLoader" class="loading-block">
            <v-progress-circular
              class="ml-2"
              v-if="getRibLoader"
              indeterminate
              color="#704ad1"
            ></v-progress-circular>
          </div>
          <div v-else class="form-add">
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="2">
                <div
                  class="block-icon-table-facture fix-width mr-1"
                  @click.prevent.stop="addLinetRibFiliale()"
                  title="Ajouter un exercice"
                >
                  <font-awesome-icon icon="plus" /> Ajouter un RIB
                </div>
              </v-col>
              <v-col cols="4"> </v-col>
            </v-row>
            <div
              v-for="(rib, index) in getRibOfFiliale"
              :key="index"
              class="card-style"
            >
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="Iban *"
                    :persistent-placeholder="true"
                    v-model="rib.iban"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="CODE SWIFT (BIC)*"
                    :persistent-placeholder="true"
                    v-model="rib.swift"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="5">
                  <v-autocomplete
                    color="#704ad1"
                    item-color="#704ad1"
                    v-model="rib.bank_id"
                    :items="getBankRows"
                    @change="rib.bank_id = $event"
                    placeholder="Séléctionnez"
                    :persistent-placeholder="true"
                    label="Banque *"
                    item-text="name"
                    item-value="id"
                    :auto-focus="false"
                    no-data-text="Aucune Banque trouvée"
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="1" class="edit-action">
                  <div
                    class="action-icon validate mr-2"
                    @click="handleSubmitRibFiliale(rib)"
                    v-if="!rib.hasOwnProperty('id')"
                  >
                    <font-awesome-icon
                      title="Ajouter Rib"
                      icon="check"
                      class="fa-2x bell1 m-1"
                    />
                  </div>
                  <div
                    class="action-icon validate mr-2"
                    @click="handleUpdateRibFiliale(rib)"
                    v-if="rib.hasOwnProperty('id') && rib.blocked === false"
                  >
                    <font-awesome-icon
                      title="Modifier rib"
                      icon="check"
                      class="fa-2x bell1"
                    />
                  </div>

                  <div
                    class="action-icon mr-2"
                    @click="BlockUnblockRibFilialeClick(rib)"
                    v-if="rib.blocked == true && rib.hasOwnProperty('id')"
                  >
                    <font-awesome-icon
                      title="Déblocker rib"
                      icon="eye-slash"
                      class="fa-2x bell1 m-2"
                    />
                  </div>
                  <div
                    class="action-icon mr-2"
                    @click="BlockUnblockRibFilialeClick(rib)"
                    v-if="rib.blocked == false && rib.hasOwnProperty('id')"
                  >
                    <font-awesome-icon
                      title="blocker rib"
                      icon="eye"
                      class="fa-2x bell1 m-2"
                    />
                  </div>

                  <div
                    class="action-icon cancel mr-2"
                    @click="DeleteRibFiliale(index, rib)"
                    v-if="!rib.hasOwnProperty('id')"
                  >
                    <font-awesome-icon icon="times" class="fa-2x bell1 m-2" />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    label="Code banque"
                    :persistent-placeholder="true"
                    v-model="rib.code_bank"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Code Guichet"
                    :persistent-placeholder="true"
                    v-model="rib.code_guichet"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="N de compte"
                    :persistent-placeholder="true"
                    v-model="rib.num_compte"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="RIB Clé"
                    :persistent-placeholder="true"
                    v-model="rib.cle_rib"
                    outlined
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    color="#704ad1"
                    item-color="#704ad1"
                    v-model="rib.familles"
                    multiple
                    :items="computedFamilles"
                    placeholder="Séléctionnez"
                    :persistent-placeholder="true"
                    label="Famille"
                    item-text="famille"
                    item-value="famille"
                    :auto-focus="false"
                    no-data-text="Aucune Famille trouvée"
                    outlined
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item, rib)"
                      >
                        {{ data.item.famille }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
        <v-divider class="line-hr-footer"></v-divider>
        <v-card-actions class="actions-msg-btn-modal">
          <div class="error-block success-message" v-if="displayModification">
            Les modifications ont été appliquées avec succès.
          </div>

          <div v-if="ribErrors" class=" error-block message-error-modal">
            <ul v-if="Array.isArray(ribErrors)" class="mb-0">
              <li v-for="(e, index) in ribErrors" :key="index">
                {{ e }}
              </li>
            </ul>
            <div class="message-error-modal" v-else>
              {{ ribErrors }}
            </div>
          </div>
          <div v-if="getErrorsRibs" class="error-block message-error-modal">
            <ul v-if="Array.isArray(getErrorsRibs)" class="mb-0">
              <li v-for="(e, index) in getErrorsRibs" :key="index">
                {{ e }}
              </li>
            </ul>
            <div class="message-error-modal" v-else>
              {{ getErrorsRibs }}
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'ribs',
  props: {
    item: { required: true }
  },
  data() {
    return {
      filialeToUpdate: null,
      addModalRib: false,
      ribErrors: null,
      displayModification: false
    };
  },
  computed: {
    ...mapGetters([
      'getRibOfFiliale',
      'getErrorsRibs',
      'getRibLoader',
      'getBankRows',
      'familles'
    ]),
    computedFamilles() {
      return this.familles.map(item => {
        return { famille: item };
      });
    }
  },
  methods: {
    ...mapActions([
      'getAllBanks',
      'getAllRibOfFiliale',
      'addRibToFiliale',
      'updateRibFiliale'
    ]),
    async handleSubmitRibFiliale(rib) {
      if (rib.swift === '' || rib.swift === null) {
        this.ribErrors = 'iban , swift et bank sont obligatoirs';
        return;
      }
      if (rib.iban === '' || rib.iban === null) {
        this.ribErrors = 'iban , swift et bank sont obligatoirs';
        return;
      }
      if (rib.bank_id === '' || rib.bank_id === null) {
        this.ribErrors = 'iban , swift et bank sont obligatoirs';
        return;
      }
      const response = await this.addRibToFiliale({
        filiale_id: this.filialeToUpdate.id,
        swift: rib.swift,
        iban: rib.iban,
        bank_id: rib.bank_id,
        code_bank: rib.code_bank,
        code_guichet: rib.code_guichet,
        num_compte: rib.num_compte,
        cle_rib: rib.cle_rib,
        familles: rib.familles
      });
      if (response) {
        this.ribErrors = null;
        this.displayModification = true;
        setTimeout(() => {
          this.displayModification = false;
        }, 2500);
      }
    },
    async DeleteRibFiliale(index) {
      this.getRibOfFiliale.splice(index, 1);
    },
    async BlockUnblockRibFilialeClick(rib) {
      const response = await this.updateRibFiliale({
        id: rib.id,
        swift: rib.swift,
        iban: rib.iban,
        bank_id: rib.bank_id,
        favori: rib.favori,
        code_bank: rib.code_bank,
        code_guichet: rib.code_guichet,
        num_compte: rib.num_compte,
        cle_rib: rib.cle_rib,
        blocked: rib.blocked ? false : true,
        familles: rib.familles
      });
      if (response == true) {
        this.displayModification = true;
        setTimeout(() => {
          this.displayModification = false;
        }, 1000);
      }
    },
    async handleUpdateRibFiliale(rib) {
      if (rib.swift === '' || rib.swift === null) {
        this.ribErrors = 'iban et swift sont obligatoirs';
        return;
      }
      if (rib.iban === '' || rib.iban === null) {
        this.ribErrors = 'iban et swift sont obligatoirs';
        return;
      }
      if (rib.bank_id === '' || rib.bank_id === null) {
        this.ribErrors = 'iban , swift et bank sont obligatoirs';
        return;
      }
      const response = await this.updateRibFiliale({
        filiale_id: this.filialeToUpdate.id,
        id: rib.id,
        swift: rib.swift,
        iban: rib.iban,
        bank_id: rib.bank_id,
        favori: rib.favori,
        blocked: rib.blocked,
        familles: rib.familles,
        code_bank: rib.code_bank,
        code_guichet: rib.code_guichet,
        num_compte: rib.num_compte,
        cle_rib: rib.cle_rib
      });
      if (response) {
        this.ribErrors = null;
        this.displayModification = true;
        setTimeout(() => {
          this.displayModification = false;
        }, 2500);
      }
    },
    remove(item, rib) {
      let index;
      rib.familles.map((famille, i) => {
        if ((famille = item.famille)) {
          index = i;
        }
      });
      if (index >= 0) rib.familles.splice(index, 1);
    },
    async ribFiliale(filiale) {
      this.filialeToUpdate = { ...filiale };
      this.getAllBanks();
      this.handleModalRib('rib', 'show');
      await this.getAllRibOfFiliale(this.filialeToUpdate.id);
    },
    addLinetRibFiliale() {
      this.getRibOfFiliale.push({
        swift: null,
        iban: null,
        bank: null,
        blocked: false,
        code_bank: null,
        code_guichet: null,
        num_compte: null,
        cle_rib: null,
        familles: []
      });
    },
    handleModalRib(method, action) {
      if (method == 'rib') {
        if (action == 'show') {
          this.addModalRib = true;
        } else {
          this.addModalRib = false;
          this.filialeToUpdate = null;
          this.isLoading = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.error-block {
  margin-left: 45%;
}
.success-message {
  color: green !important;
}
.edit-action {
  padding-top: 0px !important;
  padding-bottom: 10px !important;
  margin-top: 0 !important;
  width: 5%;
  display: flex;
  font-size: 7px;
  /* justify-content: space-between; */
  height: 80px;
  align-content: center;
  align-items: center;

  .action-icon {
    cursor: pointer;
  }

  .validate {
    color: green;
  }

  .cancel {
    color: #ab2525;
  }
}
.loading-block {
  margin-left: 50%;
  margin-top: 1%;
}
button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  color: #fff;
}
.card-style {
  border-radius: 10px;
  border: 1px solid #b5b5b5;
  padding: 28px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.fix-width {
  width: 105px !important;
  padding-bottom: 23px;
  margin-left: 70%;
  padding-left: 8px;
  margin-top: 5%;
}
</style>
